import * as apiClient from '../api/apiClient';
import { buildPagedQuery } from '../api/pagedQuery';
import { unwrapPagedResponseModel, unwrapResponseModel } from '../api/responseModel';

const INDEX_PATH = '/api/Carreras/Index';

async function requestAndUnwrap(requestPromise) {
  const { data } = await requestPromise;
  return unwrapResponseModel(data);
}

export function resetCarrerasListCacheForTests() {
  // Sin caché deduplicada tras F4-011.
}

export function listCarreras(query = { page: 1, pageSize: 10 }) {
  const qs = buildPagedQuery(query);
  return apiClient.get(`${INDEX_PATH}?${qs}`).then(({ data }) => unwrapPagedResponseModel(data));
}

export function lookupCarreras(query = { page: 1, pageSize: 5 }) {
  return listCarreras(query);
}

export function getCarrera(id) {
  return requestAndUnwrap(apiClient.get(`/api/Carreras/${id}`));
}

export function deleteCarrera(id) {
  return requestAndUnwrap(apiClient.get(`/api/Carreras/delete/${id}`));
}

export function saveCarrera(payload) {
  return requestAndUnwrap(apiClient.post('/api/Carreras', payload));
}
